import React, { useState, useEffect, useContext, useCallback } from "react"
import Context from "../utils/Context"
import ShowMessage from "../components/ShowMessage"
import api from "../api/api"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faThList, faSave, faXmark } from '@fortawesome/free-solid-svg-icons'

export default function ModalReturn() {
    const context = useContext(Context)

    const [returns, setReturns] = useState(context.returns)
    const [operations, setOperations] = useState()
    const [selectedOperation, setSelectedOperation] = useState('Smart Retail Loja')

    const [returnsPositions, setReturnsPositions] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16])

    useEffect(() => {
        const fetchOperations = async () => {
            api
                .fetchOperations({})
                .then((res) => {
                    if (res.data) {
                        setOperations(res.data)
                    }
                })
                .catch((e) => console.log(e))
        }

        fetchOperations()
    }, [])

    useEffect(() => {
        setReturns(context.returns)
    }, [returns])

    const handleSelectValuePriority = (event) => {
        let returnsValues = returns

        returnsValues[event.target.id].priority = Number(event.target.value)
        context.actions.setReturns(returnsValues)

        console.log(returnsValues)

        setReturns(returnsValues)
    }

    const handleSelectValue = (event) => {
        let returnsValues = returns

        returnsValues[event.target.id].position = event.target.value
        context.actions.setReturns(returnsValues)

        setReturns(returnsValues)
    }

    const addOperationIdToReturns = () => {
        if (selectedOperation) {
            const operationId = selectedOperation._id
            const updatedReturns = returns.map(returner => ({
                ...returner,
                OperationId: operationId
            }))
            setReturns(updatedReturns)
        }
    }

    const save = useCallback(async () => {
        let msg = " "
        let typeMsg = "error"

        var respSave
        let saveValidation = true

        //Verify this condition
        saveValidation = returns.every((e) => e?.position !== "")

        if (saveValidation) {
            addOperationIdToReturns()

            try {
                //Check looping necessery
                respSave = await api.saveReturns(returns)

                context.actions.setReturns(returns)

                msg = "Lista guardada"
                typeMsg = "success"

                context.actions.setMessage({ message: msg, type: typeMsg })
            } catch (error) {
                context.actions.setMessage({ message: "Erro a guardar", type: "error" })
                console.log("Error", error)
            }
        } else {
            context.actions.setMessage({ message: "Missão sem destino", type: "error" })
        }
    })

    // clear inputs
    const handleClearInputs = () => {
        context.actions.setReturns([])
        setReturns([])
    }

    const deleteEntry = (id) => {
        let returnsValues = returns

        returnsValues.splice(id, 1)

        context.actions.setReturns(returnsValues)

        setReturns(returnsValues)
    }

    const add = () => {
        let addNewReturn = returns

        console.log(addNewReturn)

        addNewReturn.push({ priority: returns.length > 0 ? (returns[returns.length - 1].priority + 1 > returnsPositions.length ? 1 : returns[returns.length - 1].priority + 1) : 1, missionName: "returns", owner: context.robotInfo?.owner ? context.robotInfo.owner : "SONAE", robotName: context.robotInfo?.name ? context.robotInfo.name : "1500PT", robotId: context.robotInfo?._id ? context.robotInfo._id : "668569a25067644208b2c3fe", areaId: context.areaId, idOperation: selectedOperation?._id })

        console.log(addNewReturn)

        context.actions.setReturns(addNewReturn)
    }

    const renderCells = (items) => {
        return (
            <>
                <div className='label' style={{ marginBottom: '20px' }}>Occupied:</div>

                <p></p>

                <div className='columns is-multiline'>
                    {items.map((item) => {
                        return <div className='column is-one-fifth' style={{ marginLeft: '20px', marginBottom: '10px', border: 'solid 1px black', borderRadius: '10px', textAlign: 'center' }}>
                            {item}
                        </div>
                    })}
                </div>
            </>
        )
    }

    return (
        <div className="modal is-active">
            <div className="modal-background"></div>

            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <header className="modal-card-head">
                    <p className="modal-card-title">Return Request</p>

                    <button
                        className="delete"
                        aria-label="close"
                        onClick={() => context.actions.setModalState({ ...context.modalState, return: false })}
                    ></button>
                </header>

                <section className="modal-card-body">
                    <div className="field mb-5">
                        <label className="label">Return Request</label>

                        {/*<div className="columns is-mobile">
                            <div className="column is-half">
                                <label className="label">
                                    <u>
                                        Operação
                                    </u>
                                </label>
                            </div>
                        </div>

                        <div>
                            <p className="control is-expanded">
                                <select
                                    style={{ minHeight: "2.5rem" }}
                                    defaultValue={selectedOperation ? selectedOperation._id : "Escolher Operação..."}
                                    onChange={handleSelectValueOperations}
                                >
                                    <option value="">Escolher Operação...</option>

                                    {operations?.map((m, i) =>
                                        <option key={i} id={i} value={m?._id}>
                                            {m?.name}
                                        </option>
                                    )}
                                </select>
                            </p>
                        </div>*/}

                        <div className="columns is-multiline is-mobile">
                            <div className="column is-half">
                                <label className="label">
                                    <u>
                                        Pick
                                    </u>
                                </label>
                            </div>

                            <div className="column is-half">
                                <label className="label">
                                    <u>
                                        Drop
                                    </u>
                                </label>
                            </div>

                            {returns.map((e, idx) =>
                                <div className="column is-full">
                                    <div className="field has-addons">
                                        <p className="control column is-half">
                                            <select
                                                id={idx}
                                                style={{ minHeight: "2.5rem", width: '100%' }}
                                                defaultValue={"Choose position..."}
                                                onChange={handleSelectValue}
                                                value={returns[idx].position}
                                            >
                                                <option value="">Choose position...</option>
                                                {context.designations.map((m, i) =>
                                                    <option key={i} value={m?.position}>
                                                        {m?.description}
                                                    </option>
                                                )}
                                            </select>
                                        </p>

                                        <div className="control column">
                                            <div className="select">
                                                <select
                                                    id={idx}
                                                    onChange={handleSelectValuePriority}
                                                    style={{
                                                        paddingLeft: '13px',
                                                        paddingRight: '28px'
                                                    }} >

                                                    {returnsPositions.map((r) => {
                                                        if (returns.some(ret => ret.priority === r)) {
                                                            return <option disabled selected={r === e.priority ? true : false}>{r}</option>
                                                        } else {
                                                            return <option selected={r === e.priority ? true : false}>{r}</option>
                                                        }
                                                    })}
                                                </select>
                                            </div>

                                            <div className="icon is-small is-left">
                                                <i className="fas fa-globe"></i>
                                            </div>
                                        </div>

                                        <p className="control is-vcentered">
                                            <button
                                                onClick={() => deleteEntry(idx)}
                                                className="button is-danger"
                                            >
                                                <FontAwesomeIcon icon={faXmark} className="is-small" />
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="control mb-5">
                        <button className="button is-light" onClick={add}>
                            Add
                        </button>
                    </div>

                    <ShowMessage />

                    <div className="control">
                        <button className="button is-success is-pull-left mb-2" onClick={save} style={{ marginRight: "1rem" }}>
                            <FontAwesomeIcon icon={faSave} className="is-small mr-1" />
                            Save changes
                        </button>

                        <button className="button is-pull-left is-danger mb-2" style={{ marginRight: "1rem" }} onClick={handleClearInputs}>
                            <FontAwesomeIcon icon={faTrash} className="is-small mr-1" />
                            Reset all
                        </button>

                        <button className="button is-success is-pull-right" style={{ marginRight: "1rem" }} onClick={() => context.actions.setModalState({ ...context.modalState, return: false })}>
                            Close
                        </button>
                    </div>
                </section>
            </div>
        </div>
    )
}